// src/utils/axiosConfig.js
import axios from 'axios';

let logoutCallback = null;

export const setLogoutCallback = (callback) => {
  logoutCallback = callback;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_DATABASE_URL,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isUnauthorized = error.response && error.response.status === 401;
    const isLoginPage = window.location.pathname === '/';

    if (isUnauthorized && !isLoginPage && typeof logoutCallback === 'function') {
      logoutCallback(); // Call React-side handler
    }

    return Promise.reject(error);
  }
);

export default api;